export const blue = '#114B89'
export const red = '#EF4036'
export const green = '#37B34A'
export const purple = '#8C4FB7'
export const orange = '#EE682F'
export const yellow = '#D3D335'

export const categories = {
  Libraries: red,
  'Parks, Trails & Green Spaces': green,
  'Arts & Culture': purple,
  'Regional, Sports, and Civic Facilities': blue,
  Transit: orange,
  'Municipal Support': yellow,
}
